import {
  CALENDAR_PREVIEW_CLASS_MAP,
  type TCalendarPreviewHeaderProps,
} from "@/ui/components/form/Calendar/CalendarPreview.config";
import { Flex } from "@/ui/components/layout/Flex";
import { Button } from "@/ui/components/primitives/Button";
import { TextBody } from "@/ui/components/typography/TextBody";
import { TextControl } from "@/ui/components/typography/TextControl";

export const CalendarPreviewHeader = ({
  calendarId,
  closeLabel,
  date,
  editLabel,
  isOpen,
  onToggle,
  title,
}: TCalendarPreviewHeaderProps) => (
  <Flex
    justify="between"
    data-component="CalendarPreviewHeader"
    className={CALENDAR_PREVIEW_CLASS_MAP.header}
  >
    <TextBody tag="div" size={3} isResponsive={false}>
      { title }:{ " " }
      <TextControl tag="strong" size={3} isResponsive={false}>
        { date }
      </TextControl>
    </TextBody>
    <Button
      aria-controls={calendarId}
      aria-expanded={isOpen}
      variant="text"
      onClick={onToggle}
    >
      { isOpen ? closeLabel : editLabel }
    </Button>
  </Flex>
);

CalendarPreviewHeader.displayName = "CalendarPreviewHeader";
